/* EBNZ stores (DRAFT): "my store", nearest store, in-store labels on bike tiles, and bike order on collection grids. */
(function () {
  var KEY = 'ebnz_my_store';
  var dataEl = document.querySelector('script[data-ebnz-stores]');
  var stores = [];
  try { stores = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}
  var listeners = [];
  /* Page store context: undefined = use the customer's saved store; '' = no store (All e-bikes); 'Name' = this store's view */
  var ctx;

  function byName(name) {
    for (var i = 0; i < stores.length; i++) if (stores[i].name === name) return stores[i];
    return null;
  }
  function byTag(tag) {
    for (var i = 0; i < stores.length; i++) if (stores[i].tag === tag) return stores[i];
    return null;
  }
  function byCollection(url) {
    for (var i = 0; i < stores.length; i++) if (stores[i].collection === url) return stores[i];
    return null;
  }
  function get() {
    var n = null;
    try { n = localStorage.getItem(KEY); } catch (e) {}
    return byName(n);
  }
  function notify(s) { decorate(); listeners.forEach(function (fn) { try { fn(s); } catch (e) {} }); }
  function set(name) {
    try { localStorage.setItem(KEY, name); } catch (e) {}
    var s = byName(name);
    notify(s);
    return s;
  }
  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    notify(null);
  }
  function onChange(fn) { listeners.push(fn); }
  function setContext(name) { ctx = name; decorate(); }
  function current() { return ctx === undefined ? get() : byName(ctx); }
  function km(lat1, lng1, lat2, lng2) {
    var r = Math.PI / 180, dLat = (lat2 - lat1) * r, dLng = (lng2 - lng1) * r;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
  function rank(lat, lng) {
    return stores.map(function (s) { return { store: s, distance: km(lat, lng, s.lat, s.lng) }; })
      .sort(function (a, b) { return a.distance - b.distance; });
  }
  /* ok(rankedList) | fail(message) */
  function locate(ok, fail) {
    if (!('geolocation' in navigator)) { fail("Your browser can't share your location - pick a store from the list."); return; }
    navigator.geolocation.getCurrentPosition(function (pos) {
      ok(rank(pos.coords.latitude, pos.coords.longitude));
    }, function (err) {
      fail(err && err.code === 1 ? 'Location is off for this site - pick a store from the list.' : "We couldn't find your location - pick a store from the list.");
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  }
  function options(select, placeholder, selectedName) {
    var mine = arguments.length > 2 ? byName(selectedName) : get();
    select.innerHTML = '';
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = placeholder || 'Choose a store';
    select.appendChild(ph);
    [['north', 'North Island'], ['south', 'South Island']].forEach(function (g) {
      var og = document.createElement('optgroup'); og.label = g[1];
      stores.forEach(function (s) {
        if (s.island !== g[0]) return;
        var o = document.createElement('option'); o.value = s.name; o.textContent = s.name;
        if (mine && mine.name === s.name) o.selected = true;
        og.appendChild(o);
      });
      select.appendChild(og);
    });
  }

  /* Collection grids: EBNZ bikes first, then the licensee's own bikes.
     - Store collections (on the floor): the licensee's own bikes are moved below the EBNZ bikes.
     - All e-bikes with a store chosen: that store's own bikes are added after the EBNZ range
       (from <template data-ebnz-extras="Store"> rendered by the store bar), on the last page, with no filters on. */
  function head(text, attr) {
    var d = document.createElement('div');
    d.className = 'ebnz-own-head';
    d.setAttribute(attr, '');
    d.textContent = text;
    return d;
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    try { return decodeURIComponent(a.getAttribute('href').split('/products/')[1].split(/[?#\/]/)[0]); } catch (e) { return ''; }
  }
  function arrange() {
    var inner = document.querySelector('#main .product-list__inner');
    if (!inner) return;
    var ownEl = document.querySelector('script[data-ebnz-own]');
    var own = [];
    try { own = ownEl ? JSON.parse(ownEl.textContent) : []; } catch (e) {}
    var mine = current();

    /* 1. Licensee's own bikes after the EBNZ bikes */
    if (own.length) {
      var cards = [].slice.call(inner.children).filter(function (c) { return !c.hasAttribute('data-ebnz-extra') && !c.hasAttribute('data-ebnz-head'); });
      var ownCards = cards.filter(function (c) { return own.indexOf(handleOf(c)) > -1; });
      var ebnz = cards.filter(function (c) { return ownCards.indexOf(c) === -1; });
      var h = inner.querySelector('[data-ebnz-head]');
      if (ownCards.length && ebnz.length && !h) {
        var sc = ownEl && byCollection(ownEl.getAttribute('data-collection'));
        h = head(sc ? 'Own range at Electrify ' + sc.name : 'Store’s own range', 'data-ebnz-head');
      }
      var want = ebnz.concat(ownCards.length && ebnz.length ? [h] : [], ownCards);
      var now = [].slice.call(inner.children).filter(function (c) { return !c.hasAttribute('data-ebnz-extra'); });
      var same = want.length === now.length && want.every(function (c, i) { return c === now[i]; });
      if (!same) {
        if (h && want.indexOf(h) === -1 && h.parentNode) h.parentNode.removeChild(h);
        want.forEach(function (c) { inner.appendChild(c); });
        [].slice.call(inner.querySelectorAll('[data-ebnz-extra]')).forEach(function (c) { inner.appendChild(c); });
      }
    }

    /* 2. All e-bikes: add the chosen store's own bikes after the EBNZ range */
    var filtered = /[?&]filter\./.test(location.search);
    var hasNext = !!document.querySelector('#main .pagination a[rel="next"]');
    var tpl = null;
    if (mine) document.querySelectorAll('template[data-ebnz-extras]').forEach(function (t) { if (t.getAttribute('data-ebnz-extras') === mine.name) tpl = t; });
    var wantStore = tpl && !filtered && !hasNext ? mine.name : '';
    var injected = inner.querySelectorAll('[data-ebnz-extra]');
    var haveStore = injected.length ? injected[0].getAttribute('data-ebnz-extra') : '';
    if (haveStore !== wantStore) {
      [].slice.call(injected).forEach(function (n) { n.parentNode.removeChild(n); });
      if (wantStore) {
        var eh = head('Own range at Electrify ' + wantStore, 'data-ebnz-extra');
        eh.setAttribute('data-ebnz-extra', wantStore);
        inner.appendChild(eh);
        var frag = tpl.content.cloneNode(true);
        [].slice.call(frag.children).forEach(function (c) { c.setAttribute('data-ebnz-extra', wantStore); });
        inner.appendChild(frag);
      }
    }

    /* Keep the "N products" count in step with the added bikes */
    var countEl = document.querySelector('#main .product-facet__meta-bar-item--count');
    if (countEl) {
      if (!countEl.hasAttribute('data-ebnz-base')) countEl.setAttribute('data-ebnz-base', countEl.textContent);
      var baseText = countEl.getAttribute('data-ebnz-base');
      var added = inner.querySelectorAll('[data-ebnz-extra]').length - (wantStore ? 1 : 0);
      var text = added > 0 ? baseText.replace(/\d+/, function (n) { return String(Number(n) + added); }) : baseText;
      if (countEl.textContent !== text) countEl.textContent = text;
    }
  }

  /* Licensee bikes carry vendor "vendor_<store>" (needed to keep them out of the main range).
     Customers never see that: the product page shows the real brand (first word of the title),
     and the Brand filter shows "<Store> own range". */
  function storeOfVendor(v) {
    var key = String(v).replace(/^vendor_/i, '').toLowerCase();
    for (var i = 0; i < stores.length; i++) if (stores[i].tag.replace(/^stock_/, '') === key) return stores[i];
    return null;
  }
  function mask() {
    var RE = /vendor_[A-Za-z]+/g;
    /* Product page / cards: brand line */
    document.querySelectorAll('.product-meta__vendor, .product-item-meta__vendor').forEach(function (el) {
      var a = el.tagName === 'A' ? el : (el.querySelector('a') || el);
      var t = a.textContent.trim();
      if (!/^vendor_/i.test(t)) return;
      var box = el.closest('.product-meta, .product-item-meta, .product-item, .product__info');
      var title = box && box.querySelector('.product-meta__title, .product-item-meta__title');
      var st = storeOfVendor(t);
      a.textContent = (title && title.textContent.trim().split(/\s+/)[0]) || (st ? 'Electrify ' + st.name : '');
      if (a.tagName === 'A' && st) a.setAttribute('href', '/collections/all-e-bikes?store=' + st.tag.replace(/^stock_/, ''));
    });
    /* Anything else on the page (Brand filter, active filter tags) */
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeValue.indexOf('vendor_') === -1 && n.nodeValue.indexOf('Vendor_') === -1) return NodeFilter.FILTER_SKIP;
        var p = n.parentNode && n.parentNode.nodeName;
        return (p === 'SCRIPT' || p === 'STYLE' || p === 'NOSCRIPT' || p === 'TEMPLATE') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      n.nodeValue = n.nodeValue.replace(RE, function (v) { var st = storeOfVendor(v); return st ? st.name + ' own range' : 'Own range'; });
    });
  }

  /* Bike tiles: <div class="ebnz-cs" data-ebnz-card="Nelson|Tauranga"> */
  function decorate(root) {
    if (!root) { try { arrange(); } catch (e) {} try { mask(); } catch (e) {} }
    var mine = current();
    (root || document).querySelectorAll('[data-ebnz-card]').forEach(function (el) {
      var list = (el.getAttribute('data-ebnz-card') || '').split('|').filter(Boolean);
      var dot = el.querySelector('.ebnz-dot'), text = el.querySelector('[data-text]');
      if (!dot || !text) return;
      var isMine = !!(mine && list.indexOf(mine.name) > -1), label, dotClass = 'ebnz-dot';
      if (isMine) label = 'In store at ' + mine.name;
      else if (mine) { dotClass = 'ebnz-dot ebnz-dot--grey'; label = 'In ' + list.length + (list.length === 1 ? ' other store' : ' other stores'); }
      else label = list.length === 1 ? 'In store at ' + list[0] : 'In store at ' + list.length + ' locations';
      el.classList.toggle('is-mine', isMine);
      if (dot.className !== dotClass) dot.className = dotClass;
      if (text.textContent !== label) text.textContent = label; /* only touch the DOM when it changes */
    });
  }

  window.EBNZStores = { stores: stores, get: get, set: set, clear: clear, current: current, setContext: setContext, byName: byName, byTag: byTag, byCollection: byCollection, rank: rank, locate: locate, options: options, onChange: onChange, decorate: decorate, arrange: arrange };

  function start() {
    decorate();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { decorate(); }, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
